import { useEffect, useState } from 'react'
import SwitchSelector from 'react-switch-selector'
import '../../styles/Input/InputSwitchSelector.css'

{/* 
<InputSwitchSelector 
    theme='light'
    data={[]}
    setValue={setValue}
    onChange={}
/>
--inputSwitchSelectorDark: #435e48;
--inputSwitchSelectorDarkActive: #eef5ef;
--inputSwitchSelectorDarkText: #555555;
--inputSwitchSelectorLight: #eef5ef;
--inputSwitchSelectorLightActive: #bed6c1;
--inputSwitchSelectorLightText: #2e3830;
*/}

function InputSwitchSelector({ theme, data, value, setValue, onChange }) {

    const [colors, setColors] = useState('')

    function getColors() {

        var colorsFormat = null
        if (theme === 'light') {
            colorsFormat = {
                inputSwitch: getComputedStyle(document.documentElement).getPropertyValue('--inputSwitchSelectorLight'),
                inputSwitchActive: getComputedStyle(document.documentElement).getPropertyValue('--inputSwitchSelectorLightActive'),
                inputSwitchText: getComputedStyle(document.documentElement).getPropertyValue('--inputSwitchSelectorLightText'),
            }
        } else {
            colorsFormat = {
                inputSwitch: getComputedStyle(document.documentElement).getPropertyValue('--inputSwitchSelectorDark'),
                inputSwitchActive: getComputedStyle(document.documentElement).getPropertyValue('--inputSwitchSelectorDarkActive'),
                inputSwitchText: getComputedStyle(document.documentElement).getPropertyValue('--inputSwitchSelectorDarkText'),
            }
        }
        setColors(colorsFormat)

    }

    useEffect(() => {

        getColors()

    }, [])

    return (

        <div className='switchSelectorContainer'>
            <div className={['switchSelector', theme === 'light' ? 'switchSelectorLight' : 'switchSelectorDark'].join(" ")}>
                <SwitchSelector
                    options={data}
                    initialSelectedIndex={data.findIndex((item) => item.value === value)}
                    forcedSelectedIndex={data.findIndex((item) => item.value === value)}
                    onChange={(value) => onChange(value)}
                    backgroundColor={colors.inputSwitch}
                    selectedBackgroundColor={colors.inputSwitchActive}
                    wrapperBorderRadius={20}
                    optionBorderRadius={20}
                    fontSize={20}
                />
            </div>
        </div>

    )

}

export default InputSwitchSelector
